module.exports = __webpack_public_path__ + "img/img19.c0f7b2e2.png";